import { LoadableLazy } from '@confluence/loadable';

export const ApprovalActionConfirmationModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalActionConfirmationModal" */ '../src/Modals/ApprovalActionConfirmationModal.tsx'
			)
		).ApprovalActionConfirmationModal,
});
